import React, { useEffect, useState, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { ReactSVG } from "react-svg";
import "./styles/tailwind-pre-build.css";
import "@radix-ui/themes/styles.css";
import "./styles.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Cnt from "./components/Container";
import Cursor from "./components/Cursor";
import Player from "./components/Player";
import {
  Carousel,
  Button,
  ProductEl,
  VideoLaunch,
  Bordered,
  Vsv1,
  ProductElt,
  ProductEltDetail,
  DescriptionElt,
  ProductElementDetail,
} from "./components/Els";
import McDonaldsPromo from "./components/HeaderDesktop";
import { translations, basePath } from "./translations";
import MetaTags from "./MetaTags";

export const LangContext = createContext([]);

function Hero() {
  const [lang] = useContext(LangContext);

  return (
    <Cnt className="cnt-hero">
      <div className="cnt-yellow hero-cnt">
        <div className="hero">
          <ReactSVG src={`${basePath}/img/head2.svg`} />
        </div>
        <div className="hero-inner">
          <img
            src={`${basePath}/img/r3.png`}
            alt="Hero Background"
            className="Hero_Background"
          />
          <Player>
            <Button>
              <img src={`${basePath}/img/play.svg`} alt="Play Icon" />
              {translations.ctaVideo[lang]}
            </Button>
          </Player>
        </div>
      </div>
      <McDonaldsPromo
        basePath={basePath}
        ctaVideo={translations.ctaVideo}
        lang={lang}
      />
    </Cnt>
  );
}

function Grads() {
  const [lang] = useContext(LangContext);
  return (
    <Cnt className="cnt-grad centered altered">
      <h3>{translations.McCrispyData[0].title[lang]}</h3>
      <p>{translations.McCrispyData[0].description[lang]}</p>
      <div className="alt-cnt">
        <ReactSVG src={`${basePath}/img/grads.svg`} />
      </div>
      <br />
      <Button link={translations.ctaBTn[0].link[lang]} variant="v4">
        {translations.ctaBTn[0].name[lang]}
      </Button>
    </Cnt>
  );
}


export function App() {
  const [lang, setLang] = useState("de");

  useEffect(() => {
    setLang("de");
  }, []);

  useEffect(() => {
    document.title = translations.metaData[lang]?.title || "Default Title";

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        translations.metaData[lang]?.description || "Default description"
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        translations.metaData[lang]?.description || "Default description";
      document.head.appendChild(meta);
    }
  }, [lang]);

  return (
    <LangContext.Provider value={[lang, setLang]}>
          <MetaTags />
      <Header />
      <Cnt className="centered">
        <Vsv1>
          <span>
            {translations.wlc.title[lang]} &nbsp;
            <img src={`${basePath}/img/hum.svg`} style={{ height: 33 }} />
          </span>
        </Vsv1>
      </Cnt>
      <Cnt className="centered wlc_bloc"  >
        <Bordered>
          {translations.wlc.description[lang]}
          <br />
          <strong> {translations.wlc.select[lang]}</strong>
        </Bordered>
      </Cnt>
      <Cnt className="cnt-white">
        <div className="carousel-cnt ">
          <Carousel className="carousel">
            {translations.productsList.map((e, index) => (
              <ProductElt
              className="carousel"
                key={index} lang={lang}
                product={{
                  ...e,
                  name: e.name[lang],
                  desc: e.desc[lang],
                  cta: e.cta[lang],
                  link: e.link[lang],
                  multiple: e.multiple,
                  img: `${basePath}${e.img}`,
                }}
              />
            ))}
          </Carousel>
        </div>
      </Cnt> 
      <Cnt className="cnt-white">
        <div className="product_details">
          <ProductEltDetail
            product={{
              ...translations.merchandiseProductdetails[0],
              name: translations.merchandiseProductdetails[0].name[lang],
              desc: translations.merchandiseProductdetails[0].desc[lang],
              cta: translations.merchandiseProductdetails[0].cta[lang],
              img: `${basePath}${translations.merchandiseProductdetails[0].img}`,
            }}
            variant="v2"
          />
        </div>
      </Cnt>

      {/* <Cnt className="cnt-white">
        <div className="product_details">
          <DescriptionElt
            FAQ={{
              ...translations.FAQ[0],
              name: translations.FAQ[0].name[lang],
              desc: translations.FAQ[0].description[lang],
              link: translations.FAQ[0].link[lang],
              cta: translations.FAQ[0].btn[lang],
            }}
            variant="v2"
          />
        </div>
      </Cnt>
      <Cnt className="cnt-white">
        <div className="product_details">
          <DescriptionElt
            FAQ={{
              ...translations.FAQ[0],
              name: translations.FAQ[0].name[lang],
              desc: translations.FAQ[0].description[lang],
            }}
            variant="v2"
          />
        </div>
      </Cnt> */}
      <Cnt className="cnt-white">
        <div className="product_details">
          <ProductEltDetail
            product={{
              ...translations.merchandiseProductdetails[1],
              name: translations.merchandiseProductdetails[1].name[lang],
              desc: translations.merchandiseProductdetails[1].desc[lang],
              cta: translations.merchandiseProductdetails[1].cta[lang],
              img: `${basePath}${translations.merchandiseProductdetails[1].img}`,
            }}
            variant="v2"
          />
        </div>
      </Cnt> 
      <Cnt className="cnt-white">
        <div className="product_details">
          <DescriptionElt
            FAQ={{
              ...translations.FAQ[0],
              name: translations.FAQ[0].name[lang],
              desc: translations.FAQ[0].description[lang],
              link: translations.FAQ[0].link[lang],
              cta: translations.FAQ[0].btn[lang],
            }}
            variant="v2"
          />
        </div>
      </Cnt>
      <Footer />
    </LangContext.Provider>
  );
}
